import React from 'react';
import './Checkout.css';
import Subtotal from './Subtotal.js';
import { useStateValue } from './StateProvider.js';
import CheckoutProduct from './CheckoutProduct.js';

function Checkout() {
  const [{basket, user}] = useStateValue();

  return (
    <div className='checkout'>
      <div className='checkout_left'>
        <h3>Ciao {user?.displayName}</h3>
        <h2 className='checkout_title'>Il tuo carrello</h2>

        {basket.map(item => (
          <CheckoutProduct 
            id = {item.id}
            originalID= {item.originalID}
            title = {item.title}
            description = {item.description}
            image = {item.image}
            price = {item.price}
            quantity = {item.quantity}
            size = {item.size}
          />
        ))}
      </div>

      <div className='checkout_right'>
        <Subtotal />
      </div>
    </div>
  )
}

export default Checkout
